import React from 'react';
import { useQuery } from '@common/hooks';
import { useCurrentMembership } from '@identity/hooks';

import { OrganizationSidebar } from './organization-sidebar';
import { SupplierSidebar } from './supplier-sidebar';

import { OrganizationOnly } from 'works/legacy/components/auth-guard/organization-only';
import { SupplierOnly } from 'works/legacy/components/auth-guard/supplier-only';
import { SidebarQuery, SidebarQueryResponse } from '@common/graphql';

export const AppSidebar = () => {
  const { data } = useQuery<SidebarQueryResponse>(SidebarQuery);
  const currentMembership = useCurrentMembership();

  const activeMenuItem = data?.menu?.active;

  const showReports = currentMembership.hasDashboards;
  const showStaffingItem = currentMembership.canShowSidebarStaffingItem;
  const showSidebarAdminItem = currentMembership.canShowSidebarAdminItem;
  const showCandidatesItem = currentMembership.canShowSidebarCandidatesItem;
  const showOnboardingItem = currentMembership.canShowSidebarOnboardingItem;
  const showShiftItem = currentMembership.canShowShifts;
  const showSidebarBillingItem = currentMembership.canShowSidebarBillingItem;
  const showTimesheetsItem = currentMembership.canShowSidebarTimesheetsItem;
  const showOrganizationBillingItem =
    (currentMembership.canShowInvoices || currentMembership.canShowDisputes) &&
    showSidebarBillingItem;
  const showTeamItem = currentMembership.canShowSidebarTeamItem;

  return (
    <>
      <OrganizationOnly>
        <OrganizationSidebar
          showReports={showReports}
          selectedItem={activeMenuItem}
          showStaffingItem={showStaffingItem}
          showAdminItem={showSidebarAdminItem}
          showOrganizationBillingItem={showOrganizationBillingItem}
          showTimesheetsItem={showTimesheetsItem}
          showCandidatesItem={showCandidatesItem}
          showOnboardingItem={showOnboardingItem}
          showShiftItem={showShiftItem}
          showTeamItem={showTeamItem}
        />
      </OrganizationOnly>

      <SupplierOnly>
        <SupplierSidebar
          selectedItem={activeMenuItem}
          showReports={showReports}
          showTimesheetsItem={showTimesheetsItem}
          showBillingItem={showSidebarBillingItem}
          showOnboardingItem={showOnboardingItem}
          showAdminItem={showSidebarAdminItem}
        />
      </SupplierOnly>
    </>
  );
};
